window.EventTrack = window.EventTrack || {};
window.EventTrack = {
  debug_mode: false,
  sendEvent(name, data) {
    console.log(`Track: ${name}`, data);
    if (window.EventTrack.debug_mode) {
      if (data) {
        data.debug_mode = true;
      } else {
        data = { debug_mode: true };
      }
    }
    if (window.gtag) {
      window.gtag('event', name, data);
    }
  },
  /*addToCart = function () {
    self.sendEvent('add_to_cart', {});
  };
  removeFromCart = function () {
    self.sendEvent('remove_from_cart', {});
  };
  viewCart = function () {
    self.sendEvent('view_cart', {});
  };
  viewProduct = function () {
    self.sendEvent('view_item', {});
  };
  beginCheckout = function () {
    self.sendEvent('view_item', {});
  };*/
  login(method) {
    window.EventTrack.sendEvent(
      'login',
      method
        ? {
            method: method
          }
        : {}
    );
  },
  signUp(method) {
    window.EventTrack.sendEvent(
      'sign_up',
      method
        ? {
            method: method
          }
        : {}
    );
  },
  search(search_term) {
    window.EventTrack.sendEvent('search', {
      search_term: search_term
    });
  },
  upsellUpgradeAdded(toProduct, fromProduct) {
    window.EventTrack.sendEvent('upsell_upgrade', {
      to_product: toProduct,
      from_product: fromProduct
    });
  },
  crossSellAdded(data) {
    window.EventTrack.sendEvent('cross_sell', data);
  }
};
